<template>
  <!-- 增加处理只有一张banner不需要轮播但需要跳转链接的情况 -->
  <div class="banner" v-if="list.length === 1">
    <img
      :src="list[0].img"
      class="slide-img"
      alt="banner"
      @click="jumpLink(list[0].link)"
    />
  </div>
  <div
    class="banner banner-swiper-container swiper-container"
    v-else-if="list.length > 1"
  >
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in list" :key="index">
        <img
          :src="item.img"
          class="slide-img j-slide-banner"
          :pointValue="item.link"
          alt="banner-img"
          @click="jumpLink(item.link)"
        />
      </div>
    </div>
    <div class="swiper-pagination"></div>
  </div>
  <div class="banner" v-else>
    <img :src="defaultImg" class="slide-img" alt="banner" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Swiper from 'swiper';
import globalConfig from '@utiles/officialStore/globalConfig';
import openActivity, { BANNER_ACTIVITY } from '@utiles/openActivity';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export default {
  computed: {
    ...mapGetters(['gameInfoConfig', 'configDefaultLang']),
    ...mapState({
      lang: state => state.lang,
      gameId: state => state.gameId
    }),
    defaultImg() {
      return this.gameInfoConfig?.banner?.defaultImg || '';
    },
    list() {
      // 2024.08.21 星谕需求：rov,gnjoy.hk独有活动banner，后面确认全部放开可去掉
      if (+this.gameId === 371 && globalConfig.getMainHost() !== 'gnjoy.hk') {
        return [];
      }
      return (
        this.gameInfoConfig?.banner?.list?.[this.lang] ||
        this.gameInfoConfig?.banner?.list?.[this.configDefaultLang] ||
        []
      );
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  watch: {
    lang() {
      this.initSwiper();
    }
  },
  methods: {
    jumpLink(link) {
      openActivity(BANNER_ACTIVITY, link, {
        language: this.lang,
        appLanguage: this.lang,
        ...getGlobalGetLinkParams()
      });
    },
    initSwiper() {
      try {
        new Swiper('.banner-swiper-container', {
          loop: true,
          autoplay: {
            delay: 4000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          direction: 'horizontal',
          pagination: {
            el: '.swiper-pagination'
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.banner {
  display: block;
  width: 710px;
  height: 334px;
  margin: 20px auto;
}
.slide-img {
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.swiper-pagination {
  text-align: right;
  bottom: 21px;
}
@media screen and (orientation: landscape) {
  .banner {
    width: 100%;
    height: 170px;
    margin: 0 auto;
  }
}
</style>

<style lang="scss">
@import '@assets/scss/officialWebStore/_dimen.scss';
.swiper-pagination-bullet {
  background: #fff;
  width: 12px;
  height: 12px;
  opacity: 1;
  margin: 0 5px;
}
.swiper-pagination-bullet-active {
  background: $btnBg;
}
</style>
